<rid-demo-page [title]="'<rid-egg-carton>'" previousRoute="/component-lab">
  <rid-egg-carton [eggs]="7" class="mx-auto" />
  <rid-egg-carton [changeable]="false" [eggs]="6" class="mx-auto" />
  <rid-egg-carton [eggs]="10" class="mx-auto" fillColor="#27c297" />
</rid-demo-page>
